import { PricingOptionType } from '../../constants'

export const actions = {
    //user numbers
    setPropertyManagementUnitNumber: (value: number) => ({ value }),
    //input values
    setPropertyManagementInputValue: (value: number) => ({ value }),
    setRealestateCrmInputValue: (value: number) => ({ value }),
    setRealestateMarketingInputValue: (value: number) => ({ value }),
    setMarketingContactsInputValue: (value: number) => ({ value }),
    setMarketingWebsiteInputValue: (value: number) => ({ value }),
    setMarketingAppInputValue: (value: number) => ({ value }),
    //slider values
    setPropertyManagemenSliderValue: (value: number) => ({ value }),
    setRealestateCrmSliderValue: (value: number) => ({ value }),
    setRealestateMarketingSliderValue: (value: number) => ({ value }),
    setMarketingContactsSliderValue: (value: number) => ({ value }),
    setMarketingWebsiteSliderValue: (value: number) => ({ value }),
    setMarketingAppSliderValue: (value: number) => ({ value }),
    //pricing options
    setPricingOption: (option: PricingOptionType) => ({ option }),
    setCrmPricingOption: (option: PricingOptionType) => ({ option }),
    setMarketingPricingOption: (option: PricingOptionType) => ({ option }),
    setMarketingContactsPricingOption: (option: PricingOptionType) => ({ option }),
    setMarketingWebsitePricingOption: (option: PricingOptionType) => ({ option }),
    setMarketingAppPricingOption: (option: PricingOptionType) => ({ option }),
}
